import { useNavigate } from "react-router";
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/components/ui/card";

const sections = [
  {
    title: "Scorecards",
    description: "Manage lead scoring criteria and tier definitions",
    path: "/scorecards",
  },
  {
    title: "LinkedIn Connections",
    description: "Upload and manage team LinkedIn connections",
    path: "/connections-settings",
  },
  {
    title: "Team Members",
    description: "Manage team accounts and roles",
    path: "/sales",
  },
  {
    title: "Email Integration",
    description: "Connect Microsoft Outlook to sync emails with contacts",
    path: "/outlook-settings",
  },
];

export function SettingsOverview() {
  const navigate = useNavigate();
  return (
    <div className="mx-auto max-w-4xl p-6">
      <h1 className="mb-6 text-2xl font-bold">Settings</h1>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {sections.map((s) => (
          <Card
            key={s.path}
            className="cursor-pointer transition-colors hover:border-primary"
            onClick={() => navigate(s.path)}
          >
            <CardHeader>
              <CardTitle className="text-base">{s.title}</CardTitle>
              <CardDescription>{s.description}</CardDescription>
            </CardHeader>
          </Card>
        ))}
      </div>
    </div>
  );
}
